import React, { PropsWithChildren } from 'react';
import { withHydrate } from '@ecommerce/nest-ssr/common';

import LayoutDesktop from 'layouts/layout/layout.desktop';
import Breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import PartnersGrid from 'components/partners/partners-grid';
import StaticSidebar from 'components/static/sidebar';
import { StaticLayoutProps } from 'layouts/static/static-layout.interface';

import './static.desktop.scss';

const StaticLayoutDesktop: React.FC<PropsWithChildren<StaticLayoutProps>> = ({ children, title, hidePartners }) => (
    <LayoutDesktop>
        <Breadcrumbs />
        <div className="container">
            <div className="static-view">
                <div className="static-view__left">
                    <StaticSidebar />
                </div>
                <div className="static-view__right">
                    <h1 className="static-view__title">
                        {title}
                    </h1>
                    <div className="static-view__body">
                        {children}
                    </div>
                </div>
            </div>
        </div>
        {!hidePartners && <PartnersGrid />}
    </LayoutDesktop>
);

export default withHydrate(StaticLayoutDesktop, { root: '#root' }, 'views/layouts/static/static.desktop');
